import { createAsyncThunk } from "@reduxjs/toolkit";
import { type RescheduleParams } from "../../../domain/entities/all-deliveries";
import { type AllDeliveriesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const reschedule = createAsyncThunk<
  void,
  RescheduleParams,
  { dispatch: AllDeliveriesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.RESCHEDULE, async (params, { extra }) => {
  await extra.allDeliveriesRepo.reschedule(params);
});
